module.exports = __webpack_public_path__ + "img/fourth_door_off.50b41a46.png";